"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Review", {
  enumerable: true,
  get: function () {
    return _Review.Review;
  }
});
Object.defineProperty(exports, "ReviewData", {
  enumerable: true,
  get: function () {
    return _Review.ReviewData;
  }
});
Object.defineProperty(exports, "ReviewTexts", {
  enumerable: true,
  get: function () {
    return _Review.ReviewTexts;
  }
});
var _Review = require("./Review");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfUmV2aWV3IiwicmVxdWlyZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Jldmlld3MvUmV2aWV3L2luZGV4LnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBSZXZpZXcsIFJldmlld0RhdGEsIFJldmlld1RleHRzIH0gZnJvbSBcIi4vUmV2aWV3XCJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFBQSxPQUFBLEdBQUFDLE9BQUEiLCJpZ25vcmVMaXN0IjpbXX0=